import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import _ from 'lodash';
import { api, constants } from '../utils';
import { useNavigate } from 'react-router-dom';

export default function MoveOrderList(props) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    if (data !== props.data) {
      setData(props.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props])

  function deleteOrder(moveId) {
    confirmAlert({
      title: "Permanently Delete Move Order",
      message: `This will permanently delete MOV-${moveId}. Are you sure?`,
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            api
              .post(`Transfer/DeleteMoveOrder/${moveId}`)
              .then((response) => {
                if (response.data.success) {
                  setData(response.data.data);
                } else {
                  toast.error(response.data.message);
                }
              })
              .catch(api.catchHandler);
          },
        },
        {
          label: "Cancel",
        },
      ],
    });
  }

  function openOrder(moveId) {
    var nav = constants.ENDPOINTS.moveOrder + "/" + moveId;
    navigate(nav);
  }

  return (
    <>
      {_.map(data, (item, index) => {
        return (
          <div details={item} key={index} >
            <Card className="py-0">
              <CardBody className={(index % 2 === 0) ? "mobileBlueBg py-2 px-2" : "mobileBlueBgAlt py-2 px-2"}>
                <CardTitle className={(index % 2 === 0) ? "mobileBlueBg py-2 px-2" : "mobileBlueBgAlt py-2 px-2"}>
                  {item.headerDisplay}
                  {/* Display only: an order the new /m app started is finished there during the parity period. */}
                  {item.startedOn === constants.MOVE_ORDER_STARTED_ON_MOBILE ? <small className="ms-2">(new app)</small> : null}
                </CardTitle>
                {item.moveId > 0 ?
                  <Row className="justify-content-center">
                    <Col xs="6">
                      <Button children="OPEN" className="btn w-100 btn-sm" onClick={() => {
                        openOrder(item.moveId);
                      }} />
                    </Col>
                    <Col xs="6">
                      <Button children="DELETE" className="filter-button w-100 btn-sm" onClick={() => {
                        deleteOrder(item.moveId);
                      }} />
                    </Col>
                  </Row>
                  : null
                }
              </CardBody>
            </Card>
          </div>
        )
      })}
    </>
  )
}
